export const newsletterPageContentQuery = (contentBuilderFragment) => {
    return `query pageContent($canonicalUid: String) {
        entry(uid: [$canonicalUid]) {
            ... on ds_Newsletter_Entry {
                newsletterSections {
                    ... on ds_NewsletterSection_Entry {
                        newsletterSection_Articles {
                            ... on ds_NewsletterArticle_Entry {
                                articleContentBuilder {
                                    __typename
                                    ${contentBuilderFragment}
                                }
                            }
                        }
                    }
                }
            }
        }
    }`
}